var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSweSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: "#3A68A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9492 7.21739H6.69568H6.69566V2.14261C6.14117 2.26556 5.61549 2.46485 5.13043 2.72953V7.21734V7.21737H2.05079C2.01739 7.47356 2 7.73475 2 7.99999C2 8.26523 2.01739 8.52642 2.05079 8.78259H5.13041H5.13043V13.2704C5.61549 13.5351 6.14117 13.7344 6.69566 13.8574V8.78266V8.78262H13.9492C13.9826 8.52642 14 8.26523 14 7.99999C14 7.73475 13.9826 7.47356 13.9492 7.21739Z",
    fill: "#FFD435"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweSm);
export default __webpack_public_path__ + "static/media/SWE-SM.2415bda237a5e353ba0e51b3fc9c6693.svg";
export { ForwardRef as ReactComponent };